







































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
// components
import FileSelectModal from "@/components/files/modals/FileSelectModal.vue";
import BehaviorDropdown from "@/components/posts/BehaviorDropdown.vue";
import DirectFileUploadControl from "@/components/common/files/DirectFileUploadControl.vue";
// types
import { VideoPostProperties, VideoPostSettings } from "@/services/posts/postTypes/video";
import { BehaviorEnum } from "@/services/posts/types";
import { MediaType } from "@/services/files/types";
import { FILEENDPOINT } from "@/app.config";
import i18n from "@/i18n";
import { ValidationModel } from "@/services/validation/types";
import { FolderEntites } from "@/services/folders/types";
import { Getter } from "vuex-class";
import { getFileFolderEntity } from "@/services/files/fileService";
const namespace: string = "authentication";

@Component({
    components: {
        FileSelectModal,
        BehaviorDropdown,
        DirectFileUploadControl
    }
})
export default class VideoForm extends Vue {
    @Getter("getUserHasFolderAccess", { namespace }) getUserHasFolderAccess!: boolean;
    @Prop() private properties!: VideoPostProperties;
    @Prop() private channelHeight!: number;
    @Prop() private channelWidth!: number;
    @Prop() postSettings!: VideoPostSettings;

    // local state
    fileFolderEntity = FolderEntites.Files as FolderEntites;
    originalFileName = "" as string;
    localProperties = {
        path: "",
        name: "",
        caption: "",
        behavior: "" as BehaviorEnum
    } as VideoPostProperties;

    containerSize = {
        width: 0,
        height: 0
    };

    videoSize = {
        width: 0,
        height: 0,
        origWidth: 0,
        origHeight: 0
    };

    mediaTypes = [MediaType.Video];
    behaviorTypes: any = Object.keys(BehaviorEnum)
        .map(key => ({ name: i18n.t(`posts.${key}`), id: key })).filter(x => x.id !== "adjust");

    validators = {
        behavior: {
            active: null
        } as unknown as ValidationModel,
        video: {
            active: null
        } as unknown as ValidationModel
    };

    folders = FolderEntites;

    @Watch("localProperties.behavior", { immediate: true }) localPropWatch() {
        this.calcBehavior();
    }

    // lifecycle hooks
    created() {
        this.localProperties.behavior = "letterBox" as BehaviorEnum;
    }

    async mounted() {
        if (this.properties && this.properties.path) {
            this.localProperties = this.properties;
            this.fileFolderEntity = await getFileFolderEntity(this.properties.path);
        } else {
            this.$nextTick(() => {
                this.$emit("setDefaultValues", JSON.stringify(this.localProperties));
            });
        }
        this.$nextTick(() => {
            this.loadVideo();
        });
    }

    // computed
    get videoUrl(): string {
        return `${FILEENDPOINT}${this.localProperties.path}`;
    }

    get behaviorValid(): boolean {
        return this.localProperties.behavior.length > 0;
    }

    get videoValid(): boolean {
        return this.localProperties.path.length > 0;
    }

    // methods
    loadVideo() {
        if (!this.localProperties.path ||
            this.localProperties.path.length === 0) return;
        const video = this.$refs.video as HTMLVideoElement;
        const self = this;

        video.onloadeddata = () => {
            this.$emit("setDuration", video.duration);
            this.calcAspectRatio(self.channelWidth, self.channelHeight, 200, 200, video.videoWidth, video.videoHeight);
            this.calcBehavior();
        };
        video.src = this.videoUrl;
    }

    calcAspectRatio(srcWidth: number, srcHeight: number, maxWidth: number, maxHeight: number, imgWidth: number, imgHeight: number) {
        var ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
        const calc = { width: srcWidth * ratio, height: srcHeight * ratio, ratio };

        this.containerSize.width = calc.width;
        this.containerSize.height = calc.height;
        this.videoSize.width = imgWidth * calc.ratio;
        this.videoSize.height = imgHeight * calc.ratio;
        this.videoSize.origWidth = imgWidth * calc.ratio;
        this.videoSize.origHeight = imgHeight * calc.ratio;
    }

    calcBehavior() {
        if (this.localProperties.behavior !== undefined) {
            if (this.localProperties.behavior === BehaviorEnum.letterBox) {
                if (this.videoSize.origWidth > this.containerSize.width || this.videoSize.origHeight > this.containerSize.height) {
                    var ratio = Math.min(this.containerSize.width / this.videoSize.origWidth, this.containerSize.height / this.videoSize.origHeight);
                    this.videoSize.width = this.videoSize.origWidth * ratio;
                    this.videoSize.height = this.videoSize.origHeight * ratio;
                } else {
                    this.videoSize.width = this.videoSize.origWidth;
                    this.videoSize.height = this.videoSize.origHeight;
                }
            } else if (this.localProperties.behavior === BehaviorEnum.crop) {
                if (this.videoSize.origWidth > this.containerSize.width && this.videoSize.origHeight > this.containerSize.height) {
                    this.videoSize.width = this.containerSize.width;
                    this.videoSize.height = this.containerSize.height;
                } else {
                    this.videoSize.width = this.videoSize.origWidth;
                    this.videoSize.height = this.videoSize.origHeight;
                }
            } else {
                this.videoSize.width = this.containerSize.width;
                this.videoSize.height = this.containerSize.height;
            }
        }
    }

    removeVideo() {
        this.fileFolderEntity = FolderEntites.Files;
        this.localProperties.path = "";
        this.localProperties.name = "";
    }

    openFileSelect() {
        if (this.fileFolderEntity === FolderEntites.Files && this.getUserHasFolderAccess) {
            (this.$refs.fileSelectModal as any).open(this.localProperties.path);
        } else {
            (this.$refs.directFileUploadControl as any).openFileUpload();
        }
    }

    onSelect(file: any) {
        this.localProperties.path = file.fileId;
        this.localProperties.name = file.name;
        this.$nextTick(() => {
            this.loadVideo();
        });
        this.setItemName();
        this.fileFolderEntity = FolderEntites.Files;
        this.$bvModal.hide("modal-fileSelect");
    }

    onfileUploaded(file: any) {
        this.localProperties.path = file.fileId;
        this.localProperties.name = file.originalFileName;
        this.originalFileName = file.originalFileName;
        this.$nextTick(() => {
            this.loadVideo();
        });
        this.setItemName();
        this.fileFolderEntity = FolderEntites.DirectFiles;
    }

    uploadStarted() {
        this.localProperties.path = "";
        this.localProperties.name = "";
    }

    validateData() {
        this.validators.behavior.active = true;
        this.validators.video.active = true;
        return this.behaviorValid && this.videoValid;
    }

    emitData() {
        this.$emit("propertiesUpdated", this.localProperties);
    }

    setItemName() {
        const name =
            this.localProperties.caption ||
            this.originalFileName.substring(0, this.originalFileName.lastIndexOf(".")) ||
            this.localProperties.name.substring(0, this.localProperties.name.lastIndexOf("."));
        this.$emit("itemNameUpdated", name);
    }

    toggleHeaderButtons(state: boolean) {
        this.$emit("toggleHeaderButtons", state);
    }
}
